export const HEATMAP_LABEL_LAYER = {
  DAYLIGHT: "daylight",
  ENERGY: "energy",
  PV: "pv",
  WIND_RISK: "windRisk",
  WIND_ALARM: "windAlarm",
  SOUND_EMISSION: "soundEmission",
};

export const HEATMAP_LABEL_LAYER_LABELS = {
  [HEATMAP_LABEL_LAYER.DAYLIGHT]: "Daylight",
  [HEATMAP_LABEL_LAYER.ENERGY]: "Energy",
  [HEATMAP_LABEL_LAYER.PV]: "PV",
  [HEATMAP_LABEL_LAYER.WIND_RISK]: "Wind Risk",
  [HEATMAP_LABEL_LAYER.WIND_ALARM]: "Wind Alarm",
  [HEATMAP_LABEL_LAYER.SOUND_EMISSION]: "Sound Emission",
};

export const DEFAULT_HEATMAP_LABEL_DIGITS = 1;
export const MIN_HEATMAP_LABEL_DIGITS = 0;
export const MAX_HEATMAP_LABEL_DIGITS = 4;

export const DEFAULT_HEATMAP_LABEL_DIGITS_BY_LAYER = {
  [HEATMAP_LABEL_LAYER.DAYLIGHT]: DEFAULT_HEATMAP_LABEL_DIGITS,
  [HEATMAP_LABEL_LAYER.ENERGY]: DEFAULT_HEATMAP_LABEL_DIGITS,
  [HEATMAP_LABEL_LAYER.PV]: DEFAULT_HEATMAP_LABEL_DIGITS,
  [HEATMAP_LABEL_LAYER.WIND_RISK]: DEFAULT_HEATMAP_LABEL_DIGITS,
  [HEATMAP_LABEL_LAYER.WIND_ALARM]: DEFAULT_HEATMAP_LABEL_DIGITS,
  [HEATMAP_LABEL_LAYER.SOUND_EMISSION]: DEFAULT_HEATMAP_LABEL_DIGITS,
};

export const clampHeatmapLabelDigits = (digits) => {
  const value = Number(digits);
  if (!Number.isFinite(value)) return DEFAULT_HEATMAP_LABEL_DIGITS;
  return Math.max(
    MIN_HEATMAP_LABEL_DIGITS,
    Math.min(MAX_HEATMAP_LABEL_DIGITS, Math.round(value)),
  );
};
